import { render } from "./social-links.vue?vue&type=template&id=6239fb95"
import script from "./social-links.vue?vue&type=script&lang=js"
export * from "./social-links.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__